import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import ConfiguratorMultiPictureWallField from '../../../../components/fields/ConfiguratorMultiPictureWallField';
import DealershipPriceDisclaimerField from '../../../../components/fields/DealershipFields/DealershipPriceDisclaimer';
import TranslatedMarkdownField from '../../../../components/fields/TranslatedMarkdownField';
import CollapsibleWrapper, { Panel } from '../../../../components/wrappers/CollapsibleWrapper';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import { allowedExtensions } from '../../../../utilities/extensions';
import useSystemSwitchData from '../../../../utilities/useSystemSwitchData';

export type ModelConfiguratorPageFormProps = {
    updated?: string;
    isEdit?: boolean;
    offset?: string;
    disabled?: boolean;
};

const ModelConfiguratorPageForm = ({ updated, isEdit, offset, disabled = false }: ModelConfiguratorPageFormProps) => {
    const { t } = useTranslation(['modelConfiguratorDetails']);

    const { yesNoSwitch } = useSystemSwitchData();

    return (
        <CollapsibleWrapper defaultActiveKey={t('modelConfiguratorDetails:sections.page')}>
            <Panel
                key={t('modelConfiguratorDetails:sections.page')}
                header={t('modelConfiguratorDetails:sections.page')}
            >
                <Row gutter={14}>
                    <Col lg={8} xs={24}>
                        <FormFields.TranslatedInputField
                            {...t('modelConfiguratorDetails:fields.pageTitle', { returnObjects: true })}
                            disabled={disabled}
                            name="pageTitle"
                            required
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <FormFields.TranslatedInputField
                            {...t('modelConfiguratorDetails:fields.pageSubtitle', { returnObjects: true })}
                            disabled={disabled}
                            name="pageSubtitle"
                            required
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <TranslatedMarkdownField
                            {...t('modelConfiguratorDetails:fields.pageDescription', { returnObjects: true })}
                            disabled={disabled}
                            name="pageDescription"
                            required
                            withContentRefinement
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <ConfiguratorMultiPictureWallField
                            {...t('modelConfiguratorDetails:fields.hostedImages', { returnObjects: true })}
                            disabled={disabled}
                            extensions={allowedExtensions.image}
                            max={3}
                            name="descriptionImages"
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <FormFields.TranslatedInputField
                            {...t('modelConfiguratorDetails:fields.configuratorTitle', { returnObjects: true })}
                            disabled={disabled}
                            name="configuratorTitle"
                            required
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <FormFields.InputField
                            {...t('modelConfiguratorDetails:fields.externalUrl', { returnObjects: true })}
                            addonBefore="https://"
                            disabled={disabled}
                            name="externalUrl"
                            required
                        />
                    </Col>
                    {isEdit && (
                        <Col lg={8} xs={24}>
                            <DealershipPriceDisclaimerField
                                {...t('modelConfiguratorDetails:fields.priceDisclaimerTitle', { returnObjects: true })}
                                disabled={disabled}
                                name="priceDisclaimer"
                                isEdit
                                isMultipleEntry
                            />
                        </Col>
                    )}
                    <Col lg={8} xs={24}>
                        <FormFields.SwitchField
                            {...t('modelConfiguratorDetails:fields.active', { returnObjects: true })}
                            disabled={disabled}
                            name="isActive"
                            {...yesNoSwitch}
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <FormFields.InputField
                            {...t('modelConfiguratorDetails:fields.urlIdentifier', { returnObjects: true })}
                            disabled={disabled}
                            name="urlIdentifier"
                            required
                        />
                    </Col>
                    {updated && (
                        <Col lg={8} xs={24}>
                            <FormFields.DisplayFieldWithUTCOffset
                                {...t('common:fields.updated', { returnObjects: true, offset })}
                                value={updated}
                            />
                        </Col>
                    )}
                </Row>
            </Panel>
        </CollapsibleWrapper>
    );
};

export default ModelConfiguratorPageForm;
